module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    帳務ID\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.accountInfo.accounting_id) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    訂單ID\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('router-link', {
    attrs: {
      "target": "_blank",
      "to": '/orderInfo/' + _vm.accountInfo.order_id
    }
  }, [_vm._v(_vm._s(_vm.accountInfo.order_id))]), _vm._v("  \n                    "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-target": "#orderModal",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.checkOrderInfo
    }
  }, [_vm._v("訂單交易資訊")])], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    付款類型\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.vendor_type === 707) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("LINE PAY")]) : (_vm.accountInfo.vendor_type === 701) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("iPASS MONEY")]) : (_vm.accountInfo.vendor_type === 710) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("信用卡")]) : (_vm.accountInfo.vendor_type === 713) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("台灣Pay")]) : (_vm.accountInfo.vendor_type === 716) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("全盈+PAY")]) : (_vm.accountInfo.vendor_type === 717) ? _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("悠遊付")]) : (_vm.accountInfo.vendor_type === 718) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Pi 拍錢包")]) : (_vm.accountInfo.vendor_type === 719) ? _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("全支付")]) : (_vm.accountInfo.vendor_type === 720) ? _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("icash Pay")]) : (_vm.accountInfo.vendor_type === 908) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("街口支付")]) : (_vm.accountInfo.vendor_type === 909) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("遠傳電信代收")]) : _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("其他")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易類型\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.accounting_type === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("付款")]) : (_vm.accountInfo.accounting_type === 2) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("退款")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    對帳進度\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.is_confirmed) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已完成")]) : (!_vm.accountInfo.is_confirmed) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未完成")]) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    最後狀態\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.accountInfo.latest_status === 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("成功")]) : (_vm.accountInfo.latest_status === 2) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("失敗 訂單帳務有衝突")]) : (_vm.accountInfo.latest_status === 3) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("成功 帳務紀錄有缺")]) : (_vm.accountInfo.latest_status === 4) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("成功 帳務記錄冗余")]) : _c('span', {
    staticClass: "label label-default"
  }, [_vm._v("尚未對帳")])])]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易編號 (ID)\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.trade_no) + " (" + _vm._s(_vm.accountInfo.trade_id) + ")\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易金額\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                $ " + _vm._s(_vm.accountInfo.money) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    交易日期\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.trade_date) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    更新時間\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.update_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    建立時間\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.accountInfo.create_time) + "\n              ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticClass: "col-xs-12 table-responsive p-x-0"
  }, [_c('br'), _vm._v(" "), _c('h5', [_vm._v("對帳歷史紀錄")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.trackingList), function(track, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.tracking_id))]), _vm._v(" "), _c('td', [(track.status === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("成功")]) : (track.status === 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 訂單帳務有衝突")]) : (track.status === 3) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務紀錄有缺")]) : (track.status === 4) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("失敗 帳務記錄冗余")]) : _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("尚未對帳")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.change_remark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.create_time))])])
  }), 0)]), _vm._v(" "), _c('br'), _c('br')])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-left"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("對帳ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("對帳狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("備註")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "orderModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("訂單交易資訊")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('pre', {
    attrs: {
      "id": "order-info"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d73b376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CashAccount/CashAccountInfo.vue
// module id = 2369
// module chunks = 1